import { createSingleTicketActivationMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useSingleTicketActivationMutation = createSingleTicketActivationMutation(HTTP_CONFIG.API.Consumer.url)
